import React, { useEffect, useMemo, useState } from "react";
import styles from "./InfertilityDetail2.module.css";
import { useParams } from "react-router-dom";
import pagesService from "../../services/pages";
import branchesService from "../../services/branches";
import { formatDate } from "../home-page/gallery-list/gallery-card/GalleryCard";
import RelatedItems from "./related-items/RelatedItems";
import BranchesList from "../service-detail/branches-slider/BranchesList";
import LoadingSpinner from "../../components/loader/LoadingSpinner";
import SEO from "../../components/SEO/SEO";
import { TypingEffect } from "../../components/typing-effect/TypingEffect";
import useDeviceWidth from "../../components/device-width/UseDeviceWidth";
import AdjustFontSize from "../../components/adjust-font-size/AdjustFontSize";
import ShareButtons from "../../components/share-buttons/ShareButtons";
import { useSelector } from "react-redux";

const InfertilityDetail2 = () => {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);
  // const [pages, setPages] = useState([]);
  // const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [responsiveHtml, setResponsiveHtml] = useState("");
  const width = useDeviceWidth();
  const { homeApis } = useSelector((state) => state.widget);

  // Memoize services and branches to prevent unnecessary re-renders
  const pages = useMemo(() => homeApis?.pages || [], [homeApis?.pages]);
  const branches = useMemo(
    () => homeApis?.branches || [],
    [homeApis?.branches]
  );

  // Update responsive HTML content when pageData or width changes
  useEffect(() => {
    if (pageData?.description) {
      setResponsiveHtml(AdjustFontSize(pageData.description, width));
    }
  }, [pageData, width]);

  useEffect(() => {
    let isMounted = true; // Prevents setting state on unmounted component

    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch all data in parallel
        // const [pageRes, pagesRes, branchesRes] = await Promise.all([
        const [pageRes] = await Promise.all([
          pagesService.getBySlug(slug),
          pagesService.getAll("?categorySlug=infertility-treatment"),
          // branchesService.getAll(),
        ]);

        if (isMounted) {
          console.log("FETCHED PAGE DATA:", pageRes?.data);
          // console.log("FETCHED BLOGs:", pagesRes?.data);
          // console.log("FETCHED BRANCHES:", branchesRes?.data);

          setPageData(pageRes?.data);
          // setPages(pagesRes?.data);
          // setBranches(branchesRes?.data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Cleanup function to prevent memory leaks
    };
  }, [slug]);

  return (
    <>
      {pageData && <SEO seo={pageData} />}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className={styles.container}>
          <div className={styles.description}>
            <div className={styles.divA}>
              <section className={styles.banner}>
                <div className={styles.bannerBack}>
                  <img
                    src={
                      width > 568
                        ? "/img/designs/detail-back2.png"
                        : "/img/designs/detail-back2-mob.png"
                    }
                    alt="bannerBack"
                    className={styles.bannerBack}
                  />
                </div>
                <div className={styles.imageSection}>
                  <img
                    data-aos="fade"
                    data-aos-delay="200"
                    src={
                      pageData?.images?.find(
                        (item) => item?.mainImage === "yes"
                      )?.url
                    }
                    alt={
                      pageData?.images?.find(
                        (item) => item?.mainImage === "yes"
                      )?.imageTag
                    }
                  />
                </div>
                <div className={styles.titleSection}>
                  {/* <div
                    className={styles.imageDiv}
                    data-aos="fade-down"
                    data-aos-delay="200"
                  >
                    <img
                      src={service.icon || "/img/default-icon.png"}
                      alt={service.image?.imageTag || "Service Icon"}
                      loading="lazy"
                    />
                  </div> */}
                  <p data-aos="fade-right" data-aos-delay="200">
                    {pageData.title}
                  </p>
                </div>
              </section>
              {/* <div className={styles.div1}>
                  <img
                    src="https://via.placeholder.com/150"
                    alt="Service"
                    className={styles.div1Image}
                  />
                  <div className={styles.div1Content}>
                    <span className={styles.date}>June 4, 2025</span>
                    <h2 className={styles.title}>Comprehensive Health Checkup</h2>
                  </div>
                </div> */}
              <div
                className={`${styles.serviceContent} detail-description`}
                dangerouslySetInnerHTML={{ __html: responsiveHtml }}
              />
              <ShareButtons />
            </div>
            <div className={styles.divB}>
              <RelatedItems
                data={pages?.filter((blog) => blog?.slug !== slug)}
              />
            </div>
          </div>
          {branches.length > 0 && (
            <div className={styles.branchSlider}>
              <BranchesList data={branches} />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default InfertilityDetail2;
